<template>
  <div id="bcell">
    <InnerContent>
      <ContentHeader title="B-Cell Activity in Neuroinflammation"/>

        <div class="image-container">
          <transition-group name="image-fade">
            <img
              key="pathway-1"
              v-show="currentTab === 1"
              :src="assetPath+'img/diagram-pathway-1.jpg'" 
              alt="Once B-cells cross the blood–brain barrier, they can transform into antigen-presenting cells. These antigen-presenting cells then bind to autoreactive C D 4 plus T-cells within the central nervous system, activating them to release proinflammatory cytokines. Proinflammatory cytokine release contributes to damage of the myelin sheath and may impair oligodendrocyte activity."
            >
            <img 
              key="pathway-2"
              v-show="currentTab === 2" 
              :src="assetPath+'img/diagram-pathway-2.jpg'" 
              alt="Within the central nervous system, B-cells can be activated to directly release proinflammatory cytokines, contributing to autoreactive damage to myelin and other components of the central nervous system."
            >
            <img 
              key="pathway-3"
              v-show="currentTab === 3" 
              :src="assetPath+'img/diagram-pathway-3.jpg'" 
              alt="Inside the central nervous system, B-cells can transform into antibody-producing plasma cells. These plasma cells release autoantibodies, which may promote axonal damage and complement-mediated demyelination through antigen-binding activity."
            >
          </transition-group>
        </div>

      <div class="tab-nav-container">
        <button @click="selectTab(1)" :class="currentTab === 1 ? 'active' : ''">B-Cell Contribution in MS 1</button>
        <button @click="selectTab(2)" :class="currentTab === 2 ? 'active' : ''">B-Cell Contribution in MS 2</button>
        <button @click="selectTab(3)" :class="currentTab === 3 ? 'active' : ''">B-Cell Contribution in MS 3</button>
      </div>
    </InnerContent>
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader';

export default {
  name: 'BCell',
  components: {
    ContentHeader
  },
  data() {
    return {
      currentTab: null,
      assetPath:'/',
      analyticsLabels: {
        1: 'B-Cell Contribution in MS 1',
        2: 'B-Cell Contribution in MS 2',
        3: 'B-Cell Contribution in MS 3'
      }
    }
  },
  watch: {
    currentTab(newVal) {
      this.$store.updateLastTab(newVal);
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'references') {
      this.$store.updateLastTab();
    }
    next();
  },
  beforeMount() {
    this.selectTab(this.$store.state.lastTab || 1);
  },
    mounted(){
    console.log('url>>',process.env.NODE_ENV)
    if(process.env.NODE_ENV ==="development"){
      this.assetPath="/"
    }else{
      this.assetPath="./"
    }
  },
  methods: {
    selectTab(selectedTab){
      if (selectedTab === this.currentTab) return;
      this.currentTab = selectedTab;

      this.$gtag.event('click', {'event_category': 'set_current_tab','event_label': this.analyticsLabels[selectedTab]});
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/scss/styles.scss';

  #bcell {
    width: 100%;
		position: relative;
    background: $blue-dark;
    
    .inner-content {
      padding-bottom: 20px;
    }
  }

  .content-background {
		background: $blue-dark;
  }

  .image-container {
    width: 100%;
    position: relative;
    margin: 0 auto;

    @include breakpoint(md) {
        display: flex;
        align-items: center;
        width: 66%;
        margin: 0 auto;
    }

    img {
      width: 100%;
    }
  }

  .tab-nav-container {
    width: 80%;
    margin: 0 auto;
    padding: 20px 0;
    display: flex;
    justify-content: space-between;

    button {
      font-size: rem(17px);
      color: $white;
      border: 2px solid $white;
      background: transparent;
      padding: rem(15px) rem(10px);
      width: 33%;
      margin-right: 16px;

      &:last-child {
        margin-right: 0;
      }
      &.active {
        background: $blue;
      }
    }
  }

  .image-fade-leave-active {
    transition: opacity 0.5s;
  }

  .image-fade-leave-active {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
  }

  .image-fade-enter, .image-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
